import React from 'react'
import axios from 'axios'
import qs from 'qs'
import {ActionSheet, Dialog, Toptips, Toast} from 'react-weui'
import {WKSwitchTab, WKInfiniteScroll, WKPreload} from '../../components/wk/'
import RefundItemList from './refundItemList'
import RefundReject from './refundReject'
import RefundApply from './refundApply'
import {NoneItem} from '../../components/details'
import '../../css/page/refundPage.css'
import { getAccessToken } from '../../utils'
import RefundEdit from '../../components/refund'
import { WKOwnDialog } from '../../components/wk'
import { calculate } from '../../utils/calculate'
import {isProdMainHost} from "../../config";

class Refund extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            is_sub_manager: true,
            isForbidden: false,
            initialized: true,
            tab: 0,
            refundingData: null,
            refundedData: null,
            operationTarget: null,
            isFundingLoading: false,
            isFundedLoading: false,
            isToEnd: false,
            isShowActionSheet: false,
            isShowApply: false,
            refundReject: false,
            isShowConfirmModal: false,
            isInRefundWhiteList: false,
            refundDetailedFormData:{},
            isRefundDetailedFormValidated:false,
            isShowDetailedAgreeDialog:false,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            toast: {
                icon: 'loading',
                show: false,
                content: 'loading...'
            },
            confirmModalInit: {
                buttons: [
                    {
                        type: 'default',
                        label: '取消',
                        onClick: this.unbindModal.bind(this, 'isShowConfirmModal')
                    },
                    {
                        type: 'primary',
                        label: '提交',
                        onClick: this.hideConfirmModal.bind(this),
                    }
                ]
            },
            menus: [{
                label: '查看详情',
                onClick: this.bindModal.bind(this, 'isShowApply'),
                className: 'lizhi-rwActionsheet',
            }, {
                label: '同意',
                onClick: ()=>{
                    // 直播间创建者（也可以选择退款类型）
                    // let isRoot = false
                    // try {
                    //     isRoot = (this.state.liveroomContext!==null && this.state.liveroomContext.liveroom.account_id === this.state.liveroomContext.role.account_id)
                    // } catch (e) {
                    //     console.log(e, '判断讲师身份出错')
                    // }
                    if(this.state.isInRefundWhiteList){
                        this.closeActionSheet()
                        this.setState({isShowDetailedAgreeDialog:true})
                    }else{
                        this.bindModal.bind(this, 'isShowConfirmModal')()
                    }
                },
                className: 'lizhi-rwActionsheet',
            }, {
                label: '拒绝',
                onClick: this.bindModal.bind(this, 'refundReject'),
                className: 'lizhi-rwActionsheet lizhi-rwActionsheet-reject',
            }],
            actions: [
                {
                    label: '取消',
                    onClick: this.closeActionSheet.bind(this),
                    className: 'lizhi-rwActionsheet',
                }
            ],
            liveroomContext: null
        }
    }

    componentDidMount() {
        let liveroomId = this.props.params.liveroom_id
        this.setState({liveroomId})
        this.fetchRefundingData(liveroomId)
        this.fetchLiveroomInfo(liveroomId)
        this.fetchRefundWhiteList()
    }
     // 获取退款权限白名单
     fetchRefundWhiteList(){
        let liveroom_id = this.props.params.liveroom_id
        if(!liveroom_id) return 
        const baseURL = !isProdMainHost ? 'https://gateway.test.weike.fm' : 'https://gateway-weike.lizhiweike.com'
        return axios.get(`${baseURL}/config/whitelist_access_check`, {
            params: {
                server_name: 'weike',
                key: 'refund_whitelist',
                version: '1.0',
                liveroom_id,
                token: getAccessToken()
            }
        }).then(res => {
            if(res.data.data && res.data.data.can_access) {
                this.setState({
                    isInRefundWhiteList: res.data.data.can_access
                })
            }
        }).catch(err =>{
            console.log(err)
        })
    }

    fetchLiveroomInfo(liveroomId) {
        axios.get(`/api/liveroom/${liveroomId}/info`)
            .then(res => {
                if (res.data.code === 0) {
                    let {role, liveroom} = res.data.data || {}
                    // role内可能没有accountid，通过session内取到来填充
                    if(role.account_id === undefined){
                        setTimeout(() => {
                            window.Session.getUserInfo().then(userInfo=>{
                                this.setState(state=>({
                                    liveroomContext:{
                                        ...state.liveroomContext,
                                        role:{
                                            ...state.liveroomContext.role,
                                            account_id:userInfo.id
                                        }
                                    }
                                }))
                            })
                        }, 0);
                    }
                    const ctx = {liveroom,role}
                    this.setState({is_sub_manager: role.is_sub_manager, liveroomContext:ctx})
                }
            })
    }

    fetchRefundingData(liveroomId) {
        liveroomId = liveroomId || this.state.liveroomId
        let api = `/api/liveroom/${liveroomId}/invoice/refunding_list`
        this.setState({isFundingLoading: true}, () => {
            axios.get(api, {
                params: {
                    offset: this.state.refundingData ? this.state.refundingData.next_offset : 0,
                    limit: 10
                }
            }).then(res => {
                if (res.data.code === 0) {
                    let data = res.data.data
                    if (!this.state.refundingData) {
                        this.setState({refundingData: data, initialized: false, isFundingLoading: false})
                    } else {
                        let {invoices, has_more, next_offset} = data
                        invoices = this.state.refundingData.invoices.concat(invoices)
                        this.setState({refundingData: {invoices, has_more, next_offset}, isFundingLoading: false})
                    }
                }
            }).catch(error => {
                if (error.response && error.response.status === 403) {
                    this.setState({isForbidden: true})
                }
            })
        })
    }

    fetchRefundedData(liveroomId) {
        liveroomId = liveroomId || this.state.liveroomId
        let api = `/api/liveroom/${liveroomId}/invoice/refund_list`
        this.setState({isFundedLoading: true}, () => {
            axios.get(api, {
                params: {
                    offset: this.state.refundedData ? this.state.refundedData.next_offset : 0,
                    limit: 10
                }
            }).then(res => {
                if (res.data.code === 0) {
                    let data = res.data.data
                    if (!this.state.refundedData) {
                        this.setState({refundedData: data, initialized: false, isFundedLoading: false})
                    } else {
                        let {invoices, has_more, next_offset} = data
                        invoices = this.state.refundedData.invoices.concat(invoices)
                        this.setState({refundedData: {invoices, has_more, next_offset}, isFundedLoading: false})
                    }
                }
            })
        })
    }

    bindModal(field) {
        this.closeActionSheet()
        this.setState({[field]: true})
    }

    unbindModal(field) {
        this.setState({[field]: false})
    }

    showTip(text, type = 'warn') {
        this.setState({
            tip: {isShow: true, text, type},
        })
        setTimeout(() => {
            this.setState({
                tip: {isShow: false},
            })
        }, 2000)
    }

    showToast(icon = 'loading', content, autoClose = false, time = 1000) {
        this.setState({toast: {icon, show: true, content}})
        if (autoClose) {
            setTimeout(() => {
                this.setState({toast: {icon, show: false, content}})
            }, time)
        }
    }

    hideToast() {
        let {toast} = this.state
        toast.show = false
        this.setState({toast})
    }

    closeActionSheet() {
        this.setState({isShowActionSheet: false});
    }

    openActionSheet(id) {
        const {refundingData} = this.state
        let target = refundingData.invoices.find((item) => item.id === id)
        this.setState({isShowActionSheet: true, operationTarget: target})
    }

    setTabIndex(val) {
        if (val === 0) {
            this.setState({tab: val, refundingData: null}, () => {
                this.fetchRefundingData()
            })
        }
        if (val === 1) {
            this.setState({tab: val, refundedData: null}, () => {
                this.fetchRefundedData()
            })
        }
    }

    hideConfirmModal() {
        let {operationTarget} = this.state
        this.showToast()
        axios.post(`/api/invoice/${operationTarget.id}/refund/agree`,{
            refund_type: 'normal_refund'
        }).then(res => {
                this.setState({isShowConfirmModal: false, isShowApply: false})
                if (res.data.code === 0) {
                    this.showToast('success-no-circle', '退款成功', true)
                    this.setState({refundingData: null}, () => {this.fetchRefundingData()})
                } else {
                    this.hideToast()
                    this.showTip(res.data.msg)
                }
            })
    }

    handleRejectModal(reason) {
        let {operationTarget} = this.state
        reason = reason ? reason.trim() : ''
        if (reason === '') {
            return this.showTip('理由不能为空')
        }
        this.showToast()
        axios.post(`/api/invoice/${operationTarget.id}/refund/reject`, qs.stringify({
            reason,
        })).then(res => {
            this.setState({refundReject: false, isShowApply: false})
            if (res.data.code === 0) {
                this.showToast('success-no-circle', '已拒绝', true)
                this.setState({refundingData: null}, () => {this.fetchRefundingData()})
            } else {
                this.hideToast()
                this.showTip(res.data.msg)
            }
        })
    }

    handleOpenRejectModal() {
        this.unbindModal('isShowApply')
        this.bindModal('refundReject')
    }

    handleOpenConfirmModal() {
        this.unbindModal('isShowApply')
        if(this.state.isInRefundWhiteList){
            this.setState({isShowDetailedAgreeDialog:true})
        }else{
            this.bindModal('isShowConfirmModal')
        }
    }

    handleRefundDetailedFormClickOk(){
        let {operationTarget,refundDetailedFormData,isRefundDetailedFormValidated} = this.state
        const refundTypeValueFlag = refundDetailedFormData.selectedRefundTypeValue===2 || refundDetailedFormData.selectedRefundTypeValue===3
        if(refundTypeValueFlag && !isRefundDetailedFormValidated) return
       const types = {
            0:'normal_refund',
            1: 'all_refund',
            2: 'partial_refund',
            3: 'partial_refund_all_fee'
       }
        const params = {
            refund_type:types[refundDetailedFormData.selectedRefundTypeValue],
            fee: refundTypeValueFlag
            ? calculate.mul(refundDetailedFormData.customRefund,100)
            : undefined,
            refund_reason_remark: refundDetailedFormData.reason
        }
        this.showToast()
        axios.post(`/api/invoice/${operationTarget.id}/refund/agree`,qs.stringify(params))
            .then(res => {
                this.setState({isShowDetailedAgreeDialog: false})
                if (res.data.code === 0) {
                    this.showToast('success-no-circle', '退款成功', true)
                    this.setState({refundingData: null}, () => {this.fetchRefundingData()})
                } else {
                    this.hideToast()
                    this.showTip(res.data.msg)
                }
            })
    }

    render() {
        if (this.state.isForbidden) {
            return <div className="wk-page">
                <NoneItem
                    img="https://static-1253442168.image.myqcloud.com/picture/5915685_3c997315c2944de062355158910c7f1c.jpg"
                    text="你没有查看当前页面的权限，点击返回"
                    btnMethod={e => location.assign('/')}
                    btnText='返回'
                />
            </div>
        }

        if (this.state.initialized) {
            return <div className="refund wk-page"><WKPreload/></div>
        }

        const nickName = (this.state.operationTarget 
            && this.state.operationTarget.account_info.nickname) || ''
        
        return (
            <div className="refund wk-page">
                {(this.state.isShowApply || this.state.refundReject) && <div className="refund-mask"/>}
                <Toast icon={this.state.toast.icon} show={this.state.toast.show}>{this.state.toast.content}</Toast>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>

                <WKSwitchTab tabName={['退款申请', '退款记录']} isSelectIndex={this.state.tab} tabFixed={null}
                             setTabIndex={val => this.setTabIndex(val)}/>

                {this.state.tab === 0 &&
                (this.state.refundingData ?
                        <div>
                            <RefundItemList dataList={this.state.refundingData.invoices}
                                            isSubManager={this.state.is_sub_manager}
                                            isInRefundWhiteList={this.state.isInRefundWhiteList}
                                            openActionSheet={(status, id) => this.openActionSheet(status, id)}
                                            type="refunding"/>
                            <WKInfiniteScroll
                                onTouchBottom={() => this.fetchRefundingData()}
                                isStop={this.state.isFundingLoading}
                                distance={100}
                                isKill={!this.state.refundingData.has_more}
                                isShowLoading={true}
                            />
                        </div>
                        :
                        <WKPreload/>
                )}

                {this.state.tab === 1 &&
                (this.state.refundedData ?
                        <div>
                            <RefundItemList dataList={this.state.refundedData.invoices}
                                            openActionSheet={(status, id) => this.openActionSheet(status, id)}
                                            type="refunded"/>
                            <WKInfiniteScroll
                                onTouchBottom={() => this.fetchRefundedData()}
                                isStop={this.state.isFundedLoading}
                                distance={100}
                                isKill={!this.state.refundedData.has_more}
                                isShowLoading={true}
                            />
                        </div>
                        :
                        <WKPreload/>
                )}

                {/* 详细版退费 */}
                <WKOwnDialog 
                    type="ios" 
                    title={{   
                                0:`是否同意【${nickName}】的退款申请？`,
                                1:`是否对【${nickName}】全额退款？`,
                                2:`是否对【${nickName}】部分退款？`,
                                3:`是否对【${nickName}】部分退款（不扣除手续费）？`
                    }[this.state.refundDetailedFormData.selectedRefundTypeValue]
                    }
                    buttons={[
                        {type: 'default', label: '取消', onClick: () =>{
                            this.setState({ isShowDetailedAgreeDialog: false })
                        }},
                        {type: 'primary', label: '确定', onClick: () =>this.handleRefundDetailedFormClickOk()},
                    ]}
                    show={this.state.isShowDetailedAgreeDialog}>
                    {
                        this.state.operationTarget && (
                            <RefundEdit 
                            onChange={({form,isValidated})=>{
                                console.log(form,isValidated);
                                this.setState(state=>({
                                    ...state,
                                    isRefundDetailedFormValidated:isValidated,
                                    refundDetailedFormData:form
                                }))
                            }}
                            nickname={nickName}
                            amount={parseFloat(this.state.operationTarget.fee)} />
                        )
                    }
                </WKOwnDialog>

                {this.state.operationTarget &&
                <Dialog className="refund-apply-dialog" type="ios" buttons={this.state.confirmModalInit.buttons} show={this.state.isShowConfirmModal}>
                    <div>
                        <p className="refund-title">
                            同意<span className="refund-dialog__account">【{this.state.operationTarget.account_info.nickname}】</span>的退款？
                        </p>
                        <div>
                            退款将收取<span className="refund-dialog__account refund-dialog__sub_account">【{this.state.operationTarget.account_info.nickname}】</span>的 1% 手续费
                        </div>
                    </div>
                </Dialog>
                }

                <ActionSheet
                    menus={this.state.menus}
                    actions={this.state.actions}
                    show={this.state.isShowActionSheet}
                    type="ios"
                    onRequestClose={e => this.setState({isShowActionSheet: false})}
                />

                <RefundReject data={this.state.operationTarget}
                              isShow={this.state.refundReject}
                              clickHandle={{
                                  handleReject: this.handleRejectModal.bind(this),
                                  handleClose: this.unbindModal.bind(this, 'refundReject')
                              }}/>
                <RefundApply data={this.state.operationTarget}
                             isShow={this.state.isShowApply}
                             clickHandle={{
                                 handleApply: this.handleOpenConfirmModal.bind(this),
                                 handleReject: this.handleOpenRejectModal.bind(this),
                                 handleClose: this.unbindModal.bind(this, 'isShowApply')
                             }}/>
            </div>
        )
    }

}

export default Refund



// WEBPACK FOOTER //
// ./src/pages/refund/refund.js